// Keep API permission names and expose camelCase aliases used by existing views.
export const authPermissionModel = (permissions = {}) => ({
  ...permissions,
  ...Object.fromEntries(
    Object.entries(permissions).map(([key, level]) => [
      key.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase()),
      level,
    ]),
  ),
  orientation: permissions.orientations ?? permissions.orientation ?? 0,
});
